/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).animate( {width: 'toggle'} );
      } );

      $( '.dropdown-toggle' ).on( 'toggleAfter', ( event ) => {
        $( $( event.target ).attr( 'data-toggle-target' ) ).slideToggle();
      } );

      const mediaQuery = window.matchMedia( '(max-width: 1025px)' );

      if ( mediaQuery.matches ) {
        // Then trigger an alert
        $( '.dropdown-subitem-toggle' ).on( 'toggleAfter', ( event ) => {
          $( $( event.target ).next() ).slideToggle();
        } );
      }

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle' ).removeClass( 'is-open' );
      } );

      // BUTTON ANIMATIONS

      $( '.primary-btn-blue' ).each( function() {
        const blueTxt = $( this ).text( );
        const newblueTxt = blueTxt.replace( /\w/g, function( c ) {
          return '<span>'+c+'</span>';
        } );
        $( this ).attr( 'data-text', blueTxt ).html( newblueTxt );
      } );

      $( '.primary-btn-white' ).each( function() {
        const whiteTxt = $( this ).text( );
        const newWhiteTxt = whiteTxt.replace( /\w/g, function( c ) {
          return '<span>'+c+'</span>';
        } );
        $( this ).attr( 'data-text', whiteTxt ).html( newWhiteTxt );
      } );

      const whiteTxt = $( '.primary-btn-white' ).text( );
      const newWhiteTxt = whiteTxt.replace( /\w/g, function( c ) {
        return '<span>'+c+'</span>';
      } );
      $( '.primary-btn-white' ).attr( 'data-text', whiteTxt ).html( newWhiteTxt );

      $( '.icon-heart-btn-blue' ).each( function() {
        const iconBlueTxt = $( this ).text( );
        const newIconBlueTxt = iconBlueTxt.replace( /\w/g, function( c ) {
          return '<span>'+c+'</span>';
        } );
        $( this ).attr( 'data-text', iconBlueTxt ).html( newIconBlueTxt );
      } );

      $( '.icon-heart-btn-white' ).each( function() {
        const iconWhiteTxt = $( this ).text( );
        const newIconWhiteTxt = iconWhiteTxt.replace( /\w/g, function( c ) {
          return '<span>'+c+'</span>';
        } );
        $( this ).attr( 'data-text', iconWhiteTxt ).html( newIconWhiteTxt );
      } );

      $( '.icon-play-btn-blue' ).each( function() {
        const playBlueTxt = $( this ).text( );
        const newPlayBlueTxt = playBlueTxt.replace( /\w/g, function( c ) {
          return '<span>'+c+'</span>';
        } );
        $( this ).attr( 'data-text', playBlueTxt ).html( newPlayBlueTxt );
      } );

      $( '.icon-play-btn-white' ).each( function() {
        const playWhiteTxt = $( this ).text( );
        const newPlayWhiteTxt = playWhiteTxt.replace( /\w/g, function( c ) {
          return '<span>'+c+'</span>';
        } );
        $( this ).attr( 'data-text', playWhiteTxt ).html( newPlayWhiteTxt );
      } );

      // ANNOUNCEMENT BAR

      if ( !sessionStorage.getItem( 'gp_alert_banner_dismissed', 'true' ) ) {
        console.log( 'adding banner' );
        $( '.navbar .alert-banner' ).show();
      }

      // alert banner
      let alertBanHeight = $( '.alert-banner' ).outerHeight();
      console.log( 'Height: ' + alertBanHeight );

      // Sets alertBarHeight variable
      const setalertBanHeight = ( height ) => {
        console.log( height );
        // const root = document.documentElement;
        document.documentElement.style.setProperty( '--alertBanHeight', `${height}px` );
      };

      // Set alert Banner onload;
      if ( $( '.alert-banner' ).length !== 0 ) {
        if ( sessionStorage.getItem( 'gp_alert_banner_dismissed', 'true' ) ) {
          setalertBanHeight( 0 );
          $( '.navbar .alert-banner' ).hide();
        } else {
          setalertBanHeight( alertBanHeight );
          $( '.navbar .alert-banner' ).show().addClass( 'is-showing' );
        }
      }

      console.log( $( '.alert-banner' ) );

      // Triggered in debouce function when screen is resized
      $( document ).on( 'updatealertBan', ( event ) => {
        if ( $( '.alert-banner' ).length !== 0 ) {
          const currentHeight = $( '.alert-banner' ).outerHeight();
          if ( currentHeight !== alertBanHeight ) {
            alertBanHeight = currentHeight;
            setalertBanHeight( alertBanHeight );
          }
        }
      } );

      // even listener for the close button
      $( '.close-alert' ).on( 'click', function() {
        // $( '.alert-banner' ).addClass( 'hidden' );
        $( '.navbar .alert-banner' ).hide();
        sessionStorage.setItem( 'gp_alert_banner_dismissed', 'true' );
        const root = document.documentElement;
        root.style.setProperty( '--alertBanHeight', `0px` );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
